<div [id]="id" [ngStyle]="{ 'max-width': maxWidth }">
  <header id="{{ id }}-header" [class.banner]="!!banner">
    <h1 mat-dialog-title class="pb-2">{{ title }}</h1>
    <button mat-button mat-dialog-close><mat-icon mat-dialog-close>close</mat-icon></button>
  </header>
  <!-- / header -->

  <ng-container *ngIf="banner">
    <ng-container *ngTemplateOutlet="banner"></ng-container>
  </ng-container>
  <!-- / banner -->

  <main mat-dialog-content id="{{ id }}-content">
    <ng-content></ng-content>
  </main>
  <!-- / content -->

  <footer
    mat-dialog-actions
    id="{{ id }}-footer"
    class="justify-content-end pt-3 pb-3"
    *ngIf="!hideFooter"
    [class.footer-portrait-override]="displayService.isPortrait"
  >
    <ng-container *ngIf="counter">
      <h3 class="counter">{{ counter }} {{ 'button.selected' | translate }}</h3>
    </ng-container>

    <ng-container *ngIf="!backButton; else backButtonRef">
      <button mat-button mat-dialog-close>
        {{ cancel ?? 'button.cancel' | translate }}
      </button>
    </ng-container>

    <ng-template #backButtonRef>
      <button mat-button (click)="back.emit()">
        {{ 'button.back' | translate }}
      </button>
    </ng-template>

    <button mat-raised-button color="primary" [disabled]="isLoadingData || !isValid || isSaving" (click)="onSubmit()">
      {{ confirmation ?? 'button.update' | translate }}
    </button>
  </footer>
  <!-- / footer -->
</div>
<!-- / wrapper -->
